import { render } from "./TestReportAOV.vue?vue&type=template&id=654a83aa&scoped=true&ts=true"
import script from "./TestReportAOV.vue?vue&type=script&lang=ts"
export * from "./TestReportAOV.vue?vue&type=script&lang=ts"

import "./TestReportAOV.vue?vue&type=style&index=0&id=654a83aa&scoped=true&lang=css"
import "./TestReportAOV.vue?vue&type=style&index=1&id=654a83aa&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-654a83aa"]])

export default __exports__